import React from "react";
import styled from "@emotion/styled";
import colors from "../../../sass/brand_palette.scss";

const VideoPlayer = styled.iframe`
    width: 800px;
    height: 400px;
    max-width: 100vw;
    background-image:url(/assets/img/front/icons/loading-dots-blue123.svg);
    background-repeat:no-repeat;
    background-position:center center;
    background-size: 76px 20px;
    background-color: ${colors.grey3};
    
    @media (max-width:767px){
        width: 100vw;
        height: 250px;
    }
`;

export const YoutubePlayer = (props) => {
    return (
        <VideoPlayer src={props.data.videoUrl}></VideoPlayer>
    );
}